const radius = {
  xs: 0.125 + "rem",
  sm: 0.25 + "rem",
  base: 0.375 + "rem",
  md: 0.5 + "rem",
  lg: 0.75 + "rem",
  xl: 1 + "rem",
  // each
  button: 0.25 + "rem",
  checkbox: 0.325 + "rem",
}
export default radius
